import { DefaultAvatarIcon, PhotoIcon } from '@repo/icons';
import { cn } from '@repo/utils/cn';
import Image, { StaticImageData } from 'next/image';
import { Button } from '../button';

type AvatarProps = {
  src?: string | StaticImageData;
  handleEdit?: () => void;
  className?: string;
  imgClassName?: string;
};

export const Avatar = ({ src, handleEdit, className, imgClassName }: AvatarProps) => {
  return (
    <div className={cn('relative h-12 w-12', className)}>
      {src ? (
        <Image
          src={src}
          alt="user-avatar"
          className={cn('h-full w-full flex-shrink-0 rounded', imgClassName)}
        />
      ) : (
        <DefaultAvatarIcon
          data-testid="default-avatar-icon"
          className={cn('h-full w-full flex-shrink-0 rounded', imgClassName)}
        />
      )}
      {typeof handleEdit === 'function' && (
        <Button
          variant="secondary"
          className="absolute bottom-0 right-0 h-fit rounded-full !border-[var(--stroke-light)] p-2"
          onClick={handleEdit}
        >
          <PhotoIcon />
        </Button>
      )}
    </div>
  );
};
